window.addEventListener("load", function() {
    const list = document.querySelector('#productIngredients');
    const ingredient = document.querySelector('#ingredientInput');
    const arrayIngredients = list.value.split(',').map(item => item.trim().toLowerCase());
  
    const inputError = document.querySelector('.pore-clogger-form__input-error');
    const inputErrorTextArea = document.querySelector('.pore-clogger-form__input-error-textarea');
    const ingredientsResultNotFound = document.getElementById('ingredientsResultNotFound');
    const ingredientsResultFound = document.getElementById('ingredientsResultFound');
    const ingredientsResult = document.getElementById('ingredientsResult');
    const poreCloggerProducts = document.querySelector('.pore-clogger-products');
  
    document.querySelector('.section-pore-clogger-checker .pore-clogger-form__check').addEventListener('click', onBtnCheckClick);
    document.querySelector('.section-pore-clogger-checker .pore-clogger-form__clear').addEventListener('click', onBtnClearClick);
  
    function onBtnCheckClick() {
      poreCloggerProducts.classList.add('hidden');
  
      if (!validateInput()) return;
  
      const searchResult = ingredientsFind(ingredient);
      ingredientsResult.innerHTML = searchResult;
  
      ingredientsResult.style.display = 'block';
      ingredient.style.display = 'none';
  
      if (document.querySelectorAll('.ingredient-found-term').length > 0) {
        ingredientsResultNotFound.style.display = 'none';
        ingredientsResultFound.style.display = 'block';
        document.querySelector('.pore-clogger-recs__title-negative').style.display = 'block';
        document.querySelector('.pore-clogger-recs__title-positive').style.display = 'none';
      } else {
        ingredientsResultNotFound.style.display = 'block';
        ingredientsResultFound.style.display = 'none';
        document.querySelector('.pore-clogger-recs__title-negative').style.display = 'none';
        document.querySelector('.pore-clogger-recs__title-positive').style.display = 'block';
      }
  
      const productTypeVal = document.querySelector('.pore-clogger-form__product-type').value;
      const skinTypeVal = document.querySelector('.pore-clogger-form__skin-type').value;
  
      moveRecommendations(productTypeVal, skinTypeVal);
      scrollToFormBottom();
    }
  
    function onBtnClearClick() {
      clearForm();
    }
  
    function validateInput() {
      const inputVal = document.querySelector('.pore-clogger-form__input').value;
      const productTypeVal = document.querySelector('.pore-clogger-form__product-type').value;
      const skinTypeVal = document.querySelector('.pore-clogger-form__skin-type').value;
  
      if (inputVal == '' && productTypeVal != '' && skinTypeVal != '') {
        inputErrorTextArea.style.display = 'block';
        inputError.style.display = 'none';
      } else if (inputVal == '' || productTypeVal == '' || skinTypeVal == '') {
        inputError.style.display = 'block';
      } else {
        inputError.style.display = 'none';
        inputErrorTextArea.style.display = 'none';
        return true;
      }
  
      return false;
    }
  
  
  
    function moveRecommendations(productType, skinType) {
      const productRecsId = `#${productType}-${skinType}`;
      const parent = document.querySelector('.pore-clogger-recs');
      const child = document.querySelector(productRecsId);
      parent.prepend(child);
      document.querySelector(productRecsId).classList.remove('hidden');
    }
  
    function scrollToFormBottom() {
      const formBottom = document.querySelector('.pore-clogger-form__bottom').offsetTop - 140;
      window.scrollTo({
        top: formBottom,
        behavior: 'smooth'
      });
    }
  
    function clearForm() {
      ingredient.value = '';
      document.querySelector('.pore-clogger-form__custom-select.products .select-items div').click();
      document.querySelector('.pore-clogger-form__custom-select.skin .select-items div').click();
      document.querySelector('.pore-clogger-form__input-error-textarea').style.display = 'none';
      document.querySelector('.pore-clogger-form__input-error').style.display = 'none';
      document.getElementById('ingredientInput').style.display = 'block';
      document.getElementById('ingredientsResultNotFound').style.display = 'none';
      document.getElementById('ingredientsResultFound').style.display = 'none';
      document.getElementById('ingredientsResult').style.display = 'none';
      document.querySelector('.pore-clogger-products').classList.add('hidden');
    }
  
    function ingredientsFind(term) {
      // Clean user input
      const cleanedTerm = term.value.replace(/[^a-zA-Z0-9,]/g, ' ');
      const queryItems = cleanedTerm.toLowerCase().split(',').map(item => item.trim());
  
      // Clean master list to match user input cleaning logic
      const cleanedArrayIngredients = arrayIngredients.map(item => item.replace(/[^a-zA-Z0-9,]/g, ' ').toLowerCase().trim());
  
      if (queryItems[queryItems.length - 1].length == 0) queryItems.pop();
  
      let allIngredients = "";
  
      queryItems.forEach((item, i) => {
        if (cleanedArrayIngredients.includes(item)) {
          allIngredients += i == queryItems.length - 1 ? `<span class="ingredient-found-term">${item}</span>` : `<span class="ingredient-found-term">${item}</span>, `;
        } else {
          allIngredients += i == queryItems.length - 1 ? item : item + ', ';
        }
      });
  
      return allIngredients;
    }
  
  
    // js from section
  
    (function () {
      /* custom select */
      var customSelects = document.getElementsByClassName("pore-clogger-form__custom-select");
      var numCustomSelects = customSelects.length;
  
      for (let i = 0; i < numCustomSelects; i++) {
        var selectElement = customSelects[i].getElementsByTagName("select")[0];
        var numOptions = selectElement.length;
  
        // Ensure select is always hidden
      selectElement.style.display = 'none'; 
  
        var selectedDiv = document.createElement("DIV");
        selectedDiv.setAttribute("class", "select-selected");
        selectedDiv.innerHTML = selectElement.options[selectElement.selectedIndex].innerHTML;
        customSelects[i].appendChild(selectedDiv);
  
        var optionsDiv = document.createElement("DIV");
        optionsDiv.setAttribute("class", "select-items select-hide");
  
        for (let j = 0; j < numOptions; j++) {
          const optionDiv = document.createElement("DIV");
          optionDiv.innerHTML = selectElement.options[j].innerHTML;
          optionDiv.addEventListener("click", function (e) {
            const select = this.parentNode.parentNode.getElementsByTagName("select")[0];
            const previousSibling = this.parentNode.previousSibling;
  
            for (let k = 0, sl = select.length; k < sl; k++) {
              if (select.options[k].innerHTML == this.innerHTML) {
                select.selectedIndex = k;
                previousSibling.innerHTML = this.innerHTML;
  
                const sameAsSelected = this.parentNode.getElementsByClassName("same-as-selected");
                for (const option of sameAsSelected) {
                  option.removeAttribute("class");
                }
  
                this.setAttribute("class", "same-as-selected");
                break;
              }
            }
            previousSibling.style.color = 'black';
            previousSibling.click();
            toggleBorderRadius(previousSibling); // Trigger the border-radius change
  
          });
          optionsDiv.appendChild(optionDiv);
        }
  
        customSelects[i].appendChild(optionsDiv);
        selectedDiv.addEventListener("click", function (e) {
          e.stopPropagation();
          closeAllSelect(this);
          this.nextSibling.classList.toggle("select-hide");
          this.classList.toggle("select-arrow-active");
        });
      }
  
      function closeAllSelect(elmnt) {
        var selectItems = document.getElementsByClassName("select-items");
        var selectSelected = document.getElementsByClassName("select-selected");
        var numSelectItems = selectItems.length;
        var numSelectSelected = selectSelected.length;
        var arrNo = [];
  
        for (let i = 0; i < numSelectSelected; i++) {
          if (elmnt == selectSelected[i]) {
            arrNo.push(i);
          } else {
            selectSelected[i].classList.remove("select-arrow-active");
          }
        }
        for (let i = 0; i < numSelectItems; i++) {
          if (arrNo.indexOf(i)) {
            selectItems[i].classList.add("select-hide");
          }
        }
      }
  
      document.addEventListener("click", closeAllSelect);
  
      window.addEventListener("DOMContentLoaded", (event) => {
        var setHeight = document.querySelector('.pore-clogger-accordion-inner').offsetHeight + 80;
        document.querySelector('.pore-clogger-recs').style.marginTop = setHeight + 'px';
  
        var checkButtons = document.querySelectorAll('.check-button');
        checkButtons.forEach(function (button) {
          button.addEventListener('click', function () {
            var divElem = button.closest('div');
            var productElem = divElem.querySelector('.product');
            if (productElem) {
              var name = productElem.textContent || productElem.innerText;
              console.log("Check button clicked for product: " + name);
            }
          });
        });
      });
    })();
  
    function accordionActive(elem) {
      setTimeout(function () {
        if (elem.classList.contains('is-expanded')) {
          elem.closest('.pore-clogger-accordion-inner').classList.add('active');
        } else {
          elem.closest('.pore-clogger-accordion-inner').classList.remove('active');
        }
      }, 100);
    }
  
    // Attach event listeners to all accordion buttons
    const accordionButtons = document.querySelectorAll('.pore-clogger-accordion__button');
    accordionButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        accordionActive(this);
      });
    });
  
    // Function to toggle border-radius for the clicked element only
    function toggleBorderRadius(selectElement, isExpanded) {
      if (isExpanded) {
        // When expanded, change border-radius to 20px 20px 0 0
        selectElement.style.borderRadius = '20px 20px 0 0';
      } else {
        // When collapsed, revert back to original border-radius of 20px
        selectElement.style.borderRadius = '20px';
      }
    }
  
    // Add event listeners to each select box to toggle the border-radius individually
    document.querySelectorAll('.pore-clogger-form__custom-select .select-selected').forEach(selectBox => {
      selectBox.addEventListener('click', function (event) {
        const isExpanded = this.classList.contains('select-arrow-active');
        toggleBorderRadius(this, isExpanded);
  
        // Stop the click event from propagating further, so it doesn't trigger the page click listener
        event.stopPropagation();
      }, { passive: true }); // Add { passive: true } here
    });
  
    // Add a click listener on the page to revert the border-radius when clicking outside the select box
    document.addEventListener('click', function () {
      document.querySelectorAll('.pore-clogger-form__custom-select .select-selected').forEach(selectBox => {
        // Collapse all select boxes and reset their border-radius
        toggleBorderRadius(selectBox, false);
      });
    });
  });
  